// src/pages/NewsletterPage.js
import React from 'react';
import './NewsletterPage.css';

export function NewsletterPage() {
  return (
    <div className="newsletter-page">
      <div className="container">
        <header className="page-header">
          <h1>Supply Chain Insights Newsletter</h1>
          <p>Stay updated with the latest in AI-powered supply chain education</p>
        </header>

        <section className="newsletter-signup">
          <div className="signup-content">
            <h2>Subscribe to Newsletter</h2>
            <p>Get insights on supply chain innovation, AI applications, and educational resources delivered to your inbox.</p>
            
            <div className="substack-embed">
              <iframe
                title="Supply Chain Brutus Newsletter Signup"
                src="https://professorcastillo.substack.com/embed"
                width="100%"
                height="320"
                style={{ 
                  border: '1px solid #EEE', 
                  background: 'white',
                  borderRadius: '8px'
                }}
                frameBorder="0"
                scrolling="no"
              ></iframe>
            </div>
            
            <p className="privacy-note">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </div>
        </section>

        <section className="coming-soon">
          <div className="coming-soon-content">
            <h2>Newsletter Archive Coming Soon</h2>
            <p>We're working on integrating our Substack newsletter archive. Check back soon to browse past issues and insights!</p>
          </div>
        </section>
      </div>
    </div>
  );
}